import type { SystemStyleObject} from '@chakra-ui/react'
import { Box, Flex, Text, Tooltip } from '@chakra-ui/react'
import type { Error } from 'brokertslib/src/dtos/Error'
import WarningIcon from '../../../images/warning-icon.svg?react'

interface InsuranceTypeProps {
  label: string
  value: React.ReactNode
  valueSx?: SystemStyleObject
  valid: boolean
  errors?: Error[]
}

export const InsuranceType = ({ label, value, valueSx, valid, errors }: InsuranceTypeProps) => {
  const anyErrors = errors && errors.length > 0
  const formattedPrice =
    (anyErrors || !valid) ? undefined : value

  return (
    <Flex sx={{ width: '100%', py: 2, justifyContent: 'space-between' }}>
      <Box sx={{ fontSize: 'sm' }}>{label}</Box>

      {formattedPrice && (
        <Box sx={{ fontSize: 'md', fontWeight: 'bold', ...valueSx }}>{value}</Box>
      )}

      {!formattedPrice && (anyErrors || !valid) && (
        <Tooltip
          hasArrow
          label={anyErrors ? (
            <Flex direction="column">
              {errors?.map((x) => <Text key={x.message}>{x.message}</Text>)}
            </Flex>
          ) : undefined
          }
          placement="top"
        >
          <WarningIcon />
        </Tooltip>
      )}
    </Flex>
  )
}